/**
 * Infinity Collectables – Rotating Search Placeholder
 * Loaded via theme.liquid (deferred)
 */
(function () {
  'use strict';

  var phrases = [
    'Search for Funko Pop exclusives…',
    'Search for Pokémon booster packs…',
    'Search for Anime figures…',
    'Search for Loungefly bags…',
    'Search for One Piece collectibles…',
    'Search for Trading Card singles…',
  ];

  var idx = 0;

  function applyPlaceholder() {
    var inputs = document.querySelectorAll(
      '.search-modal input[type="search"],' +
      ' predictive-search input[type="search"],' +
      ' input[type="search"].search__input,' +
      ' .field__input[type="search"]'
    );
    if (!inputs.length) return;
    inputs.forEach(function (input) {
      if (document.activeElement === input && input.value) return;
      input.setAttribute('placeholder', phrases[idx]);
    });
    idx = (idx + 1) % phrases.length;
  }

  function init() {
    applyPlaceholder();
    setInterval(applyPlaceholder, 2500);

    // Re-apply when search modal opens (Dawn uses <details>)
    document.addEventListener(
      'toggle',
      function (e) {
        if (e.target && e.target.matches('details')) {
          setTimeout(applyPlaceholder, 50);
        }
      },
      true
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/**
 * IC EDIT (Claude): Branded search redirects
 * If a search query EXACTLY matches a known brand term, jump straight to that
 * collection instead of showing the generic search results page.
 * - Intercepts the search form submit (capture phase) so there is no flash.
 * - Also catches direct loads of /search?q=brand (e.g. from external links).
 * Exact-match only, so multi-word queries like "funko pop stand" are unaffected.
 * To add a term: add a "normalised term": "/collections/handle" pair below.
 */
(function () {
  'use strict';

  var MAP = {
    'needoh': '/collections/needoh',
    'nee doh': '/collections/needoh',
    'youtooz': '/collections/youtooz',
    'pokemon': '/collections/pokemon',
    'pokémon': '/collections/pokemon',
    'star wars': '/collections/star-wars',
    'starwars': '/collections/star-wars',
    'marvel': '/collections/marvel',
    'loungefly': '/collections/loungefly',
    'fuggler': '/collections/fuggler',
    'hot toys': '/collections/hot-toys',
    'black series': '/collections/the-black-series',
    'action figures': '/collections/action-figures',
    'action figure': '/collections/action-figures',
    'advent calendar': '/collections/advent-calendars',
    'gifts under 10': '/collections/gifts-under-10'
  };

  function norm(s) {
    return (s || '').toLowerCase().trim().replace(/\s+/g, ' ');
  }

  function target(q) {
    return MAP[norm(q)] || null;
  }

  // 1) Intercept search submissions before they navigate to /search
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.action || form.action.indexOf('/search') === -1) return;
    var input = form.querySelector('input[name="q"]');
    if (!input) return;
    var dest = target(input.value);
    if (dest) {
      e.preventDefault();
      window.location.href = dest;
    }
  }, true);

  // 2) Catch direct loads of /search?q=brand
  if (window.location.pathname.replace(/\/+$/, '') === '/search') {
    try {
      var q = new URLSearchParams(window.location.search).get('q');
      var dest = target(q);
      if (dest) window.location.replace(dest);
    } catch (e) {}
  }
})();
